<template lang="pug">
  include /mixins
  +b.media-row(v-if='list.length')
    +e.title.H5 {{ _('Фотографии и видео покупателей') }}
    +e.content
      +b.slider-box--free.relative
        +b.category-swipe-wrapper.--variant_common.fake-slider(
          data-snap-slider="main-slider"
        )
          +e.cell.--variant_5(
            v-for="(el, i) in list"
          )
            +b.review-media(
              v-if="el.props.img"
              @click="show(i)"
            )
              +e.PICTURE.image-wrapper
                +e.image.IMG(:src='el.props.img')
              +e.IMG.icon(
                :src="'/static/img/zoom-white.svg'"
              )
            ui-youtube-view(
              v-else
              :url="el.props.url"
            )
              template(#default="{ play, preview }")
                +b.review-media(@click="show(i)")
                  +e.PICTURE.image-wrapper
                    +e.image.IMG(:src="preview")
                  +e.IMG.play-icon(
                    :src="'/static/img/youtube.svg'"
                  )
        +b.ds-panel.--space_xl.--space_3xl-xl
          +e.element.--offset_top
            +b.g-row.--align_center.--justify_between
              +b.g-cell
                +b.t-controls.--variant_common.snap-controls(
                  :data-count="list.length"
                )
                  +e.item.is-disabled(
                    data-snap-slider-goto="right" :aria-label="_('Следующий слайд')"
                  )
                    +b.mdi.mdi-chevron-left
                  +e.item(
                    data-snap-slider-goto="left" :aria-label="_('Предыдущий слайд')"
                  )
                    +b.mdi.mdi-chevron-right
</template>

<script>
import { ReviewMediaList } from '@api/review.service'

export default {
  name: 'ReviewsMedia',

  props: ['id', 'type', 'product_type', 'product_id', 'title', 'info'],

  data() {
    return {
      list: [],
      timestamp: new Date(),
    }
  },

  created() {
    this.getItems()
  },

  methods: {
    show(index) {
      this.$modal.show(() => import('@app/Review-v2/MediaDetail'), {
        info: this.info,
        list: this.list,
        index,
        product_type: this.product_type,
        product_id: this.product_id,
        title: this.title,
      },
      {
        height: 'auto',
        classes: 'review-details-modal',
        adaptive: true,
        scrollable: true,
      })
    },

    async getTypedList(key) {
      const params = { key, type: this.type, id: this.id }

      const { data: { items } } = await ReviewMediaList.execute(params)

      return items.reverse()
    },

    async getItems() {
      const videos = await this.getTypedList('videos')

      this.list.push(...videos)

      const photos = await this.getTypedList('photos')

      this.list.push(...photos)
    },
  },
}
</script>
